<fi-request-access
    [open]="isRequestAccessModalOpen"
    (close)="closeRequestAccessModal()"
></fi-request-access>

<fi-track-view [data]="analyticsData"></fi-track-view>
